import { useState } from 'react';
import { GenericModal } from '@components/generic-modal';
import { MarkdownRenderer } from '@components/markdown-renderer';
import DISCLAIMER_CONTENT from '@constants/disclaimer-content';
import TERMS_CONDITIONS_CONTENT from '@constants/terms-conditions-content';
import { CURRENT_INSTANCE } from '@lib/utils';
import { useTranslation } from 'react-i18next';

function IncyteAgreementBanner() {
  const { t } = useTranslation();
  const [showTerms, setShowTerms] = useState<boolean>(false);

  return (
    <>
      <GenericModal
        open={showTerms}
        onOpenChange={setShowTerms}
        title={t('terms.title')}
        description={TERMS_CONDITIONS_CONTENT[CURRENT_INSTANCE.name].de}
      />
      <MarkdownRenderer
        content={DISCLAIMER_CONTENT[CURRENT_INSTANCE.name].de}
        onCodeClick={() => setShowTerms((prev) => !prev)}
      />
    </>
  );
}

export default IncyteAgreementBanner;
